import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { useLanguage } from "../../i18n/LanguageContext";

const TopUsersTable = ({ users }) => {
  const { t } = useLanguage();
  if (!users || users.length === 0) {
    return (
      <Card className="border border-border">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium">{t("platform.topUsers")}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground text-center py-4">{t("platform.noData")}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border border-border">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium">{t("platform.topUsers")}</CardTitle>
      </CardHeader>
      <CardContent className="px-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border text-muted-foreground text-xs">
                <th className="text-left px-4 pb-2 font-medium">#</th>
                <th className="text-left px-4 pb-2 font-medium">{t("platform.user")}</th>
                <th className="text-left px-4 pb-2 font-medium">{t("platform.clinic")}</th>
                <th className="text-right px-4 pb-2 font-medium">{t("platform.queries")}</th>
                <th className="text-right px-4 pb-2 font-medium">{t("platform.spend")}</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u, i) => (
                <tr key={u.user_id} className="border-b border-border/50 hover:bg-accent/50">
                  <td className="px-4 py-2.5 text-muted-foreground">{i + 1}</td>
                  <td className="px-4 py-2.5">
                    <div className="font-medium">{u.name || u.email}</div>
                    {u.name && <div className="text-xs text-muted-foreground">{u.email}</div>}
                  </td>
                  <td className="px-4 py-2.5 text-muted-foreground">{u.clinic_name || "—"}</td>
                  <td className="px-4 py-2.5 text-right">{u.stats.total_consultations}</td>
                  <td className="px-4 py-2.5 text-right font-medium">${u.stats.total_cost_usd.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default TopUsersTable;
